import React from 'react'

export function Divider() {
    return (
        <div className="divider-container">
            <div className="divider"></div>
            <div className="divider"></div>
            <div className="divider"></div>
        </div>
    )
}
